import { Locale, formatDisplayableCurrency } from 'utils';
import { PriceProps } from './Price.types';

export const Price = ({
  value,
  currency,
  microcopy,
  className,
  'data-test': dataTest,
}: PriceProps) => {
  return (
    <div className={className} data-test={dataTest}>
      {value === undefined
        ? microcopy?.free
        : formatDisplayableCurrency(
            parseFloat(value),
            Locale.ENGLISH,
            currency
          )}
    </div>
  );
};
